module.exports = __webpack_public_path__ + "static/media/r_itdot_8.afdf1a11.png";